import { Chip, ChipProps, Tooltip } from '@mui/material'
import { PaymentStatus, LifecycleStatus, QuotationStatus } from '@typings'
import {
  PAYMENT_STATUS_LABELS,
  PAYMENT_STATUS_COLORS,
  LIFECYCLE_STATUS_LABELS,
  LIFECYCLE_STATUS_COLORS,
  PAYMENT_STATUS_TOOLTIPS,
  LIFECYCLE_STATUS_TOOLTIPS,
  QUOTATION_STATUS_LABELS,
  QUOTATION_STATUS_COLORS,
  QUOTATION_STATUS_TOOLTIPS,
} from 'src/constants/status.constants'

interface StatusBadgeProps {
  status: PaymentStatus | LifecycleStatus | QuotationStatus | null
  type: 'payment' | 'lifecycle' | 'quotation'
  size?: ChipProps['size']
  variant?: ChipProps['variant']
}

export const StatusBadge = ({ status, type, size = 'small', variant = 'filled' }: StatusBadgeProps) => {
  if (!status) return null

  const label =
    type === 'payment'
      ? PAYMENT_STATUS_LABELS[status as PaymentStatus]
      : type === 'lifecycle'
        ? LIFECYCLE_STATUS_LABELS[status as LifecycleStatus]
        : QUOTATION_STATUS_LABELS[status as QuotationStatus]

  const color =
    type === 'payment'
      ? PAYMENT_STATUS_COLORS[status as PaymentStatus]
      : type === 'lifecycle'
        ? LIFECYCLE_STATUS_COLORS[status as LifecycleStatus]
        : QUOTATION_STATUS_COLORS[status as QuotationStatus]

  const tooltip =
    type === 'payment'
      ? PAYMENT_STATUS_TOOLTIPS[status as PaymentStatus]
      : type === 'lifecycle'
        ? LIFECYCLE_STATUS_TOOLTIPS[status as LifecycleStatus]
        : QUOTATION_STATUS_TOOLTIPS[status as QuotationStatus]

  return (
    <Tooltip title={tooltip}>
      <Chip
        label={label}
        color={color}
        size={size}
        variant={variant}
      />
    </Tooltip>
  )
}
